import React, { Suspense, useState } from 'react';
import { useInView } from 'react-intersection-observer';

const LazyRender = ({ children, height = '350px' ,id}) => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.1 });
  const [isVisible, setIsVisible] = useState(false);

  if (inView && !isVisible) {
    setIsVisible(true);
  }

  return (
    <div ref={ref} style={{ minHeight: height }} id={id}>
      {isVisible && (
        <Suspense fallback={<div>Loading...</div>}>
          {children}
        </Suspense>
      )}
    </div>
  );
};

export default LazyRender;
